import { Button, Dialog } from '../../../components/ui';
import { useT } from '../../../i18n';
import { LoiTrongHop } from '../../tenant/components/phan-form';

/**
 * Hộp xác nhận một thao tác trên người dùng, khi câu chữ đã được phía gọi dựng
 * sẵn — dùng cho các thao tác lấy lại tài khoản (gửi email đặt lại mật khẩu,
 * đặt lại xác thực hai lớp).
 *
 * Cùng khuôn `HopKhoaNguoiDung`: tiêu đề đặt câu hỏi, thân nói hậu quả, nút
 * nhắc lại đúng việc sắp xảy ra; lỗi hiện **trong** hộp, hộp không đóng.
 * `loi` là câu đã dịch — mỗi thao tác có cách nói lỗi riêng (`409` của đặt lại
 * mật khẩu nói dùng "Gửi lại lời mời"), nên phía gọi quyết.
 */
export function HopXacNhanThaoTac({
  open,
  tieuDe,
  than,
  nhanXacNhan,
  nguyHiem = false,
  dangChay,
  loi,
  onClose,
  onXacNhan,
}: {
  open: boolean;
  tieuDe: string;
  than: string;
  nhanXacNhan: string;
  /** Thao tác phá huỷ, không hoàn tác: nút đỏ. */
  nguyHiem?: boolean;
  dangChay: boolean;
  loi: string | null;
  onClose: () => void;
  onXacNhan: () => void;
}) {
  const { t } = useT();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={tieuDe}
      width={480}
      destroyOnHidden
      footer={
        <div className="flex flex-wrap justify-end gap-3">
          <Button variant="outline" size="md" onClick={onClose}>
            {t('chung.huy')}
          </Button>
          <Button
            variant={nguyHiem ? 'destructive' : 'primary'}
            size="md"
            loading={dangChay}
            onClick={onXacNhan}
          >
            {nhanXacNhan}
          </Button>
        </div>
      }
    >
      <div className="space-y-3 pt-2">
        <p className="text-sm leading-relaxed text-content-secondary">{than}</p>
        {loi && <LoiTrongHop>{loi}</LoiTrongHop>}
      </div>
    </Dialog>
  );
}
